module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-receipt-vp",
    attrs: {
      "id": "modal-receipt-vp",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modal-receipt-vp-label"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content window-print"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('button', {
    staticClass: "close hidden-print",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "receipt-header"
  }, [_c('img', {
    attrs: {
      "src": "/static/Logo_Move_Mais_Horizontal+TAG_Pedagio.svg",
      "alt": "Logo Move Mais TAG",
      "width": "120"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('h3', [_vm._v("Comprovante Vale-pedágio")]), _vm._v(" "), _c('p', {
    staticClass: "upper"
  }, [_vm._v("n° comprovante")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.summaryVP.idProtocolo))]), _vm._v(" "), _c('p', {
    staticClass: "upper"
  }, [_vm._v("data de emissão")]), _vm._v(" "), _c('p', {
    attrs: {
      "mask-date-hour": ""
    }
  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.dataHoraEmissao)))])])]), _vm._v(" "), _c('div', {
    staticClass: "receipt-info"
  }, [_c('div', {}, [_c('p', {
    staticClass: "margin-b30 upper"
  }, [_vm._v("transportador")]), _vm._v(" "), _c('p', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.summaryVP.transportador))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', {
    directives: [{
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }]
  }, [_vm._v(_vm._s(_vm.summaryVP.CNPJTransportador))])]), _vm._v(" "), _c('p', [_vm._v("N° do TAG: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.tagSerialNumber))])]), _vm._v(" "), _c('p', [_vm._v("PLACA: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.placaVeiculo))])]), _vm._v(" "), _c('p', [_vm._v("CATEGORIA: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.categoria))])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('p', {
    staticClass: "margin-b30 upper"
  }, [_vm._v("emissor")]), _vm._v(" "), _c('p', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.summaryVP.embarcador))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', {
    directives: [{
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }]
  }, [_vm._v(_vm._s(_vm.summaryVP.CPFCNPJEmbarcador))])]), _vm._v(" "), _c('p', [_vm._v("CONTRATO: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.contratoOrig))])])])]), _vm._v(" "), (_vm.summaryVP) ? _c('div', {
    attrs: {
      "id": "summary-box"
    }
  }, [_c('div', {
    staticClass: "content-box-npadd margin-b20"
  }, [_c('div', {
    staticClass: "toll-info-box"
  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-send.svg",
      "alt": "icon send"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.origin.state) + "\n                  ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-location.svg",
      "alt": "icon location"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.destination.state) + "\n                  ")])])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n                  rota:\n                  "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.rota))])]), _vm._v(" "), _c('p', [_vm._v("\n                  distância:\n                  "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n                  valor:\n                  "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n                  expiração:\n                  "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.summaryVP.expirationVP)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-toll-info"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryVP.pracas), function(p, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
  }), 0)])]), _vm._v(" "), _c('h5', {
    staticClass: "text-right upper"
  }, [_vm._v("valor total: "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])])])]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right hidden-print"
  }, [_c('button', {
    staticClass: "bbtn no-btn btn-square",
    on: {
      "click": function($event) {
        return _vm.window.print()
      }
    }
  }, [_vm._v("\n          Imprimir\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt-footer"
  }, [_c('div', {
    staticClass: "flex between"
  }, [_c('div', [_c('p', {
    staticClass: "upper"
  }, [_vm._v("move mais meios de pagamentos ltda")]), _vm._v(" "), _c('p', [_vm._v("\n                Avenida Rodrigo Fernando Grilo, 207, Edifício\n                "), _c('br'), _vm._v("\n                Victória Business 20° andar - Araraquara, SP,\n                "), _c('br'), _vm._v("\n                Brasil - 14801-534\n              ")])]), _vm._v(" "), _c('div', [_c('p', [_c('i'), _vm._v("\n                relacionamento@movemais.com\n              ")]), _vm._v(" "), _c('p', [_c('i'), _vm._v("\n                0800 777 1022\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('p', [_vm._v("Todos os direitos reservados.")]), _vm._v(" "), _c('p', [_vm._v("CNPJ: 15.266.912/0001-87")]), _vm._v(" "), _c('p', [_vm._v("Inscrição Estadual: 181.239.134.110")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-5c57ffcc!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/modal-receipt-vp.vue
// module id = 2140
// module chunks = 1